import React, { useState } from 'react'
import FluidImage from '/src/utils/FluidImage'
import WithLargeImagesPopup from './WithLargeImagesPopup'

const WithLargeImagesTeamMember = (item) => {

    const [open, setOpen] = useState(false)
    function handleSetOpen() {
        setOpen(!open)
    }

    const hasCopy = item.content.description

    return (
        <div>
            <div className={`outline-none focus:outline-none ${hasCopy ? 'group cursor-pointer' : 'cursor-default'}`} onClick={() => setOpen(true)} onKeyPress={() => setOpen(true)} role="button" tabIndex="0">
                <FluidImage image={item.content.image} className={`object-cover mb-6 rounded-md group-hover:opacity-70 group-hover:-translate-y-2 duration-300`}/>
                <h5 className="lg:text-base text-sm font-bold tracking-[-0.01em] group-hover:text-teal duration-300">{item.name}</h5>
                <h6 className="lg:text-base text-sm tracking-[-0.01em] text-darkblue-600">{item.content.position}</h6>
                {hasCopy && <WithLargeImagesPopup {...item} open={open} handleSetOpen={handleSetOpen}/>}
            </div>
            {(item.content.twitter || item.content.linkedin) &&
                <div className="flex flex-row items-center gap-4 mt-2">
                    {item.content.twitter &&
                        <a href={item.content.twitter} target="_blank" rel="noreferrer" className="lg:text-darkblue-600 text-teal hover:text-teal duration-300">
                            <i class="fa-brands fa-twitter"></i>
                        </a>
                    }
                    {item.content.linkedin &&
                        <a href={item.content.linkedin} target="_blank" rel="noreferrer" className="lg:text-darkblue-600 text-teal hover:text-teal duration-300">
                            <i class="fa-brands fa-linkedin"></i>
                        </a>
                    }
                </div>
            }
        </div>
    )
};

export default WithLargeImagesTeamMember